import { createRef, useEffect } from "react"
import Debounce from "../Debounce"

export interface IInfiniteScrollProps {
    root?:Document | Element | null | string
    threshold?:number
    debounce?:number
    onScroll:() => void
}

export default function InfiniteScroll(props:IInfiniteScrollProps) {
    const ref = createRef<HTMLDivElement>()
    const debounce$ = new Debounce<null>(props.debounce || 250)
    const onScroll = () => props.onScroll()
    useEffect(() => {
        const root = typeof(props.root)=="string" ? document.querySelector(props.root) : props.root
        const options : IntersectionObserverInit = {
            root:root,
            rootMargin: "0px",
            threshold: props.threshold || 0.25
        }
        const observer = new IntersectionObserver((entries) => entries.forEach(entry => entry.isIntersecting && debounce$.next(null)), options)
        if (ref.current) observer.observe(ref.current)
        debounce$.subscribe(onScroll)
        return () => {
            observer.disconnect()
            debounce$.unsubscribe(onScroll)
        }
    },[props.root])
    return <div className="inifite" ref={ref}></div>
}